import * as React from 'react'

interface Props {
    color?: string
    size?: number
    thickness?: number
}

export function Spinner({ color, size, thickness }: Props) {
    const style = {
        height: size && `${size}px`,
        width: size && `${size}px`,
        borderWidth: thickness && `${thickness}px`,
        borderLeftColor: color,
    }

    return <div className="AppCore__ui__Spinner" style={style} />
}
